import React from 'react'
import loadable from '@loadable/component'
import { MarkdownToJSX } from 'markdown-to-jsx'
import contentRenderer from '@/helpers/contentRenderer'
import { MarkdownBodyProps } from './types'

const Markdown = loadable(() => import('markdown-to-jsx'))

export const MarkdownBody: React.FC<MarkdownBodyProps<MarkdownToJSX.Overrides>> = ({ children }) => (
  <Markdown options={{ overrides: contentRenderer, wrapper: React.Fragment }}>{children}</Markdown>
)
